export default {
    videos: 'Videos',
    data_consumed: 'Data consumed (mb)',
    size: 'Size (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'There is no file',
    text_upload_file: 'Start uploading a new file.',
    upload: 'Upload',
    quota_label: 'Storage used',
    quota_of: '{used} of {limit}',
    quota_none: 'Your plan doesn\'t include storage, so you can\'t upload videos. Upgrade your plan to upload them.',
    quota_full: 'You\'ve used all the storage in your plan. Empty the trash or upgrade your plan to upload more videos.',
    quota_exceeded: 'The video is {size} and only {free} is free in your plan. Empty the trash or upgrade your plan.',
}